import { jsxs as c, jsx as s } from "react/jsx-runtime";
import { c as w } from "../../../index-Cu0xwYjD.js";
import { forwardRef as m } from "react";
import { isExternalLink as x } from "../../utils/utils.js";
import { s as t } from "../../../CTAButton.module-ll2XoNNI.js";
import { Icon as l } from "../Icon/Icon.js";
import { VisuallyHidden as T } from "../VisuallyHidden/VisuallyHidden.js";
const d = m(
  ({
    variant: e,
    iconRight: r = "off",
    iconLeft: f = "off",
    fullWidth: u,
    opensInNewWindow: a,
    inverted: p = !1,
    children: y,
    href: i,
    rel: n,
    target: $,
    className: v,
    ...k
  }, h) => {
    const o = `var(--el-component-cta-${e}`, g = a ? "_blank" : $;
    return x(i) && (n = `${n || ""} noopener`.trim()), r === "off" && a && (r = "new-window"), /* @__PURE__ */ c(
      "a",
      {
        ref: h,
        rel: n,
        target: g,
        href: i,
        style: {
          "--background-color": `${o}-surface)`,
          "--color": `${o}-message)`,
          "--outline-focused": `${o}-outline-focused)`,
          "--path": `${o}-message)`,
          "--surface-hover": `${o}-surface-hover)`,
          "--message-hover": `${o}-message-hover)`,
          width: u ? "100%" : {}
        },
        className: w(
          t.button,
          {
            [t.secondary]: e === "secondary",
            [t.inverted]: p
          },
          v
        ),
        ...k,
        children: [
          f !== "off" ? /* @__PURE__ */ s(l, { name: f, size: 16 }) : null,
          /* @__PURE__ */ c("span", { children: [
            y,
            a && /* @__PURE__ */ s(T, { children: " (opens in new window)" })
          ] }),
          r !== "off" ? /* @__PURE__ */ s(l, { name: r, size: 16 }) : null
        ]
      }
    );
  }
), E = m(
  (e, r) => /* @__PURE__ */ s(d, { variant: "primary", ref: r, ...e })
), H = m(
  (e, r) => /* @__PURE__ */ s(d, { variant: "secondary", ref: r, ...e })
);
export {
  d as CTALink,
  E as PrimaryCTALink,
  H as SecondaryCTALink
};
